import React, { useState } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import TournamentService from '../../../../../services/main/Tournament.service';
import Toasters from '../../../../../components/popUp/PopUp';
import Loader from '../../../../../components/loader/Loader';
import useStyles from './Modal.styles';
import { EmptyVoidFunction } from '../../../../../utils/types/Types';
import useTranslation from '../../../../../components/localization/customHooks/Translation';

const defaultProps = {
  handleClose: () => {},
};

export default function DeleteTournamentModal(props: { tournamentId: number; handleClose?: EmptyVoidFunction }) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const l10n = useTranslation();

  const sendDeleteRequest = async () => {
    setIsLoading(true);
    if (props.tournamentId) {
      const res = await TournamentService.delete(props.tournamentId);

      if (res) {
        Toasters.success(l10n.components.toasterMessage.TOURNAMENT_HAS_BEEN_DELETED);
      }
    }

    setIsLoading(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };

  return (
    <Grid className={classes.modalContent}>
      {isLoading ? (
        <Loader />
      ) : (
        <Grid className={classes.contentWrapper}>
          <Typography className={classes.contentTitle}>
            {l10n.components.confirmDialogsMessage.DELETE_TOURNAMENT}
          </Typography>
          <Button type="submit" variant="contained" color="primary" onClick={sendDeleteRequest}>
            {l10n.components.button.DELETE}
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

DeleteTournamentModal.defaultProps = defaultProps;
